const browserCheck = {
    isPc () {
        var ua = navigator.userAgent
        var isWindowsPhone = /(?:Windows Phone)/.test(ua)
        var isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
        var isAndroid = /(?:Android)/.test(ua)
        var isFireFox = /(?:Firefox)/.test(ua)
        var isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
        var isPhone = /(?:iPhone)/.test(ua) && !isTablet
        var isPad = /(?:iPad)/.test(ua)
        var isPc = !isPhone && !isAndroid && !isSymbian && !isPad
        return isPc
    },
    isAndroid () {
        var ua = navigator.userAgent
        var isAndroid = /(?:Android)/.test(ua)
        return isAndroid
    },
    isIOS () {
        var ua = navigator.userAgent
        var isIOS = /(?:iPhone)/.test(ua) || /(?:iPad)/.test(ua)
        return isIOS
    },
    isWX () {
        return /micromessenger/.test(navigator.userAgent.toLowerCase())
    }
  }
  export  default browserCheck


// WEBPACK FOOTER //
// ./src/assets/js/browser.js